<app-loading size="0.5" class="loading-spinner" *ngIf="isLoading$ | async; else wrapper"
color="var(--primary-sec-color)"></app-loading>
<ng-template #wrapper>
  <div class="choose-customer-wrapper">
    <a class="bread-crumb w-auto" [routerLink]="['../','search']">
      <mat-icon aria-hidden="false" aria-label="Back to Dashboard">chevron_left</mat-icon>
      <span>{{ 'searchCustomer.backToSearch' | translate}}</span>
    </a>
    <div class="title">
      <span>{{ 'searchCustomer.customerLookup' | translate}}</span>
    </div>

    <div class="result-container">
      <div class="customer" *ngFor="let customer of (customers$ | async)">
        <div class="name">
          <span (click)="selectCustomer(customer)">{{ getCustomerDisplayName(customer) }}</span>
          <a rel="noopener noreferrer" class="add-account-link" *ngIf="!customer.hasOwnersOrDriversAccount && !isMEXDealer"
            [href]= "checkDealerType(dealerCode$ | async)" target="_blank">+ {{ 'testDrive.addOwnersAccount' | translate}}</a></div>
          <div class="customer-row">
            <div class="text text-phone" *ngIf="!customer.drvaFlag">{{customer.phoneNumber | phone}}</div>
            <div class="text text-email" *ngIf="!customer.drvaFlag">{{customer.emailAddress}}</div>
        </div>
      </div>

      <div class="no-result" *ngIf="!(customers$ | async).length">
        <div class="button-icon">
          <mat-icon aria-hidden="false">info</mat-icon>
        </div>
        <div class="text-1">{{ 'searchCustomer.customerNotFound' | translate}}!</div>
        <div class="text-2">{{ 'searchCustomer.theCustomerCouldNotBeFoundTxt' | translate}}</div>
        <div class="selection-box">
          <a class="selection-item" [routerLink]="[appointmentType.link]"
            *ngFor="let appointmentType of appointmentTypes">
            <div class="image">
              <img [src]='appointmentType.image' alt="{{appointmentType.text}}">
            </div>
            <div class="caption" [ngSwitch]="appointmentType.text.toUpperCase()">
              <span *ngSwitchCase="'SERVICE'">{{ 'searchCustomer.service' | translate }}</span>
              <span *ngSwitchCase="'PARTS'">{{ 'navigation.parts' | translate }}</span>
              <span *ngSwitchDefault>{{ 'searchCustomer.testDrive' | translate }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>
